import { Routes } from '@angular/router';
import { ProjectViewComponent } from './Pages/project-view/project-view.component';
import { CustomerViewComponent } from './Pages/customer-view/customer-view.component';
import { TimelogSheetsViewComponent } from './Pages/timelog-sheets-view/timelog-sheets-view.component';
import { RequisitionNumberComponent } from './Pages/requisition-number-view/requisition-number.component';
import { authGuard } from '../../../../src/app/auth.guard';
import { UserRoleType } from 'BaseDataTypes';

const timelogRouteConfig: Routes = [
  { path: '', redirectTo: 'rekvisitionsnumre', pathMatch: 'full' },

  {
    path: 'rekvisitionsnumre',
    title: 'Rekvisitionsnumre',
    component: RequisitionNumberComponent,
    canActivate: [authGuard],
    data: { allowedUserRoleType: [UserRoleType.Admin] },
  },
  {
    path: 'kunder',
    title: 'Kunder',
    component: CustomerViewComponent,
    canActivate: [authGuard],
    data: { allowedUserRoleType: [UserRoleType.Admin] },
  },
  {
    path: 'projekter',
    title: 'Projekter',
    component: ProjectViewComponent,
    canActivate: [authGuard],
    data: { allowedUserRoleType: [UserRoleType.Admin] },
  },
  {
    path: 'timelog-sheets',
    title: 'Timelog-Sheets',
    component: TimelogSheetsViewComponent,
    canActivate: [authGuard],
    data: { allowedUserRoleType: [UserRoleType.Admin] },
  },
];

export default timelogRouteConfig;
